module.exports = __webpack_public_path__ + "media/printed-materials/educators-05-high-school-calendar-c8e55384.png";